import React from 'react'
import { graphql, Link } from 'gatsby'

import Layout from '../components/Layout'
import Seo from '../components/Seo'
import IconArrowRight from '../icons/arrow-right.svg'

class NotFoundPage extends React.Component {
	render() {
		const { data } = this.props
		const siteTitle = data.site.siteMetadata.title

		return (
			<Layout location={this.props.location} title={siteTitle}>
				<Seo title="404: Page not found" />
				<div className="inner-wrap-container">
					<div className="inner-wrap">
						<div className="error-wrap text-center">
							<span className="error-code">404</span>
							<h1 className="error-message h3">Page not found</h1>
							<p className="message-manual">
								Maybe the URL is incorrect, or the page no longer exist.
							</p>
							<Link
								to={`/`}
								className="btn btn-rounded btn-secondary btn-sm back-btn"
							>
								Return to home page <IconArrowRight />
							</Link>
						</div>
					</div>
				</div>
			</Layout>
		)
	}
}

export default NotFoundPage

export const pageQuery = graphql`
	query {
		site {
			siteMetadata {
				title
			}
		}
	}
`
